'use client';

import Icon from './Icon';
import svg from 'sprites/human-pain.svg';

export default function IconHumanPain({
  className = 'w-17 h-3 fill-none stroke-brown'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
